import { NotificationTable } from "../../__generated__/globalTypes";

/**
 * Correspondance `table` + `objectId` → route front.
 *
 * `table`/`objectId` ne sont pas une vraie relation SQL (§33) : la cible peut avoir
 * été supprimée. Une entrée renvoyant `null` signifie « pas de page dédiée » — on
 * retombe alors sur la liste, ou sur rien du tout si la notification n'est pas
 * cliquable (cas de l'import en masse, sans table ni objectId).
 */
const ROUTE_BUILDERS: Record<NotificationTable, ((id: number) => string) | null> = {
  [NotificationTable.Article]: (id) => `/article/${id}/update`,
  [NotificationTable.Category]: (id) => `/category/${id}`,
  [NotificationTable.Cms]: (id) => `/cms-item/${id}/update`,
  [NotificationTable.Contact]: (id) => `/contact/${id}`,
  // Pas de page par id : on ouvre la liste filtrée sur le site concerné.
  [NotificationTable.CreatedSite]: () => `/created-sites`,
  [NotificationTable.Customer]: (id) => `/customer/${id}`,
  [NotificationTable.CustomerTask]: (id) => `/customer-task/${id}/update`,
  [NotificationTable.Mailbox]: () => `/my-mailbox`,
  // Pas de page par id : liste seulement.
  [NotificationTable.MailMessage]: () => `/mail-messages`,
  [NotificationTable.PromptFragment]: (id) => `/prompt-fragment/${id}/update`,
  [NotificationTable.Prospection]: (id) => `/prospection/${id}/update`,
  [NotificationTable.Report]: (id) => `/report/${id}/update`,
  [NotificationTable.SalesArgument]: (id) => `/sales-argument/${id}/update`,
  [NotificationTable.Theme]: (id) => `/theme/${id}/update`,
  [NotificationTable.User]: (id) => `/user/${id}`,
};

export const notificationLink = (
  table?: NotificationTable | null,
  objectId?: number | null
): string | null => {
  if (!table) return null;
  const builder = ROUTE_BUILDERS[table];
  if (!builder) return null;
  if (objectId === null || objectId === undefined) return null;
  return builder(objectId);
};
